import axios from "axios";

export const AUTHORIZATION = 'Authorization';
export const BEARER = '';
export const EDITION = '1.1.0'; // 版本
export const SYSTEM_NAME = '链上剧场后台管理平台'; ///系统名称
export const COMPANY = '中慧讯科(天津)科技发展有限公司'; // 公司名
export const SUPPORT = '中慧讯科(天津)科技发展有限公司';
export const PHONE = '15620285303'; // 联系方式
export const RECORD_NUMBER = '津ICP备2022003932号-16'; //备案号
export const QUERY = 'QUERY';

export const SYS_BASE_URL = '/playlet-service';
export const FZ_BASE_URL = '/fz-service';
export const SYS_BASE_URL_ZH = '/zh-service';

export const CREATE = 'success';
export const UPDATE = 'primary';
export const DELETE = 'danger';
export const DETAIL = 'info';
export const UNBIND = 'unbind';
export const BIND = 'bind';
export const UNBIND_API = 'unbindApi';
export const BIND_API = 'bindApi';

export const SYS_DEF = "00";